export default __webpack_public_path__ + "static/media/unga agenda.2874031d.png";